function getAndroidVersion() {
    if (!isAndroid()) {
        return false;
    }
    const OSVersion = getOSVersion();
    const versionRegex = /Android \d+((.\d+))+/g;
    const matches = OSVersion.match(versionRegex);
    const version = matches ? matches[0] : '';
    const normalized = version.replace('Android ', '');
    return parseFloat(normalized);
}
function getIOSVersion() {
    if (!isIOS()) {
        return false;
    }
    const OSVersion = getOSVersion();
    const versionRegex = /OS \d+((_\d+))+/g;
    const matches = OSVersion.match(versionRegex);
    const version = matches ? matches[0] : '';
    const normalized = version.replace('OS ', '').replace(/_/g, '.');
    return parseFloat(normalized);
}
function getOSVersion() {
    const versionRegex = /\(([^)]+)\)/g;
    const matches = getUserAgent().match(versionRegex);
    return matches ? matches[0] : '';
}
function getUserAgent() {
    return navigator.userAgent;
}
function isAndroid() {
    return /Android/i.test(getUserAgent());
}
function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(getUserAgent());
}
function isIOS() {
    return /iPad|iPhone|iPod/i.test(getUserAgent()) && !window.MSStream;
}
export { getAndroidVersion, getIOSVersion, getOSVersion, getUserAgent, isAndroid, isIOS, isMobile, };
//# sourceMappingURL=mobile.js.map